import { Helmet } from "react-helmet-async";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "EasyFinder",
  "url": "https://easyfinder.fr",
  "logo": "https://easyfinder.fr/pwa-512x512.png",
  "description": "EasyFinder - Gestion intelligente de documents avec recherche en langage naturel",
  "foundingDate": "2024",
  "sameAs": [
    "https://twitter.com/easyfinder_fr",
    "https://www.linkedin.com/company/easyfinder"
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer support",
    "email": "contact@easyfinder.fr",
    "availableLanguage": ["French", "English"]
  }
};

const softwareApplicationSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "EasyFinder",
  "applicationCategory": "BusinessApplication",
  "operatingSystem": "Web, iOS, Android",
  "description": "Application de gestion documentaire intelligente avec OCR, recherche IA et partage sécurisé",
  "url": "https://easyfinder.fr",
  "screenshot": "https://easyfinder.fr/og-image.png",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "500",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": [
    {
      "@type": "Offer",
      "name": "Discovery",
      "price": "0",
      "priceCurrency": "EUR",
      "description": "Plan gratuit - 30 documents"
    },
    {
      "@type": "Offer",
      "name": "Personal",
      "price": "9.90",
      "priceCurrency": "EUR",
      "description": "Plan personnel - 5000 documents"
    },
    {
      "@type": "Offer",
      "name": "Pro",
      "price": "19.90",
      "priceCurrency": "EUR",
      "description": "Plan professionnel - 25000 documents"
    }
  ],
  "featureList": [
    "Recherche en langage naturel avec IA",
    "OCR automatique des documents scannés",
    "Classification intelligente des documents",
    "Partage sécurisé avec liens protégés",
    "Synchronisation Gmail et Dropbox",
    "Scanner de documents intégré",
    "Fusion et signature de PDF"
  ]
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Comment fonctionne la recherche intelligente d'EasyFinder ?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "EasyFinder utilise l'intelligence artificielle pour comprendre vos requêtes en langage naturel. Vous pouvez demander 'mes factures EDF de 2024' ou 'le devis du plombier de l'été dernier' et l'IA trouve les documents correspondants automatiquement."
      }
    },
    {
      "@type": "Question",
      "name": "Quels formats de documents sont supportés ?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "EasyFinder supporte les formats PDF, images (JPG, PNG, HEIC), et documents Office. L'OCR intégré permet d'extraire le texte des documents scannés et des photos de documents."
      }
    },
    {
      "@type": "Question",
      "name": "Mes documents sont-ils sécurisés ?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Oui, vos documents sont chiffrés avec AES-256 et stockés sur des serveurs sécurisés en Europe. Les liens de partage sont protégés et vous gardez le contrôle total sur l'accès à vos fichiers."
      }
    },
    {
      "@type": "Question",
      "name": "Puis-je importer mes emails automatiquement ?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Oui, EasyFinder se connecte à Gmail et Outlook pour importer automatiquement les pièces jointes importantes (factures, contrats, attestations). L'import intelligent filtre les newsletters et spam."
      }
    },
    {
      "@type": "Question",
      "name": "EasyFinder fonctionne-t-il sur mobile ?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Oui, EasyFinder est une Progressive Web App (PWA) installable sur iPhone et Android. Vous pouvez scanner des documents avec votre appareil photo et accéder à vos fichiers même hors ligne."
      }
    }
  ]
};

const webSiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "EasyFinder",
  "url": "https://easyfinder.fr",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://easyfinder.fr/documents?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export const JsonLd = () => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(softwareApplicationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(webSiteSchema)}
      </script>
    </Helmet>
  );
};
